import { createSlice } from '@reduxjs/toolkit';

export const tasks = createSlice({
  name: 'tasks',
  initialState: {
    allComments: [],
    boardActivities: [],
    myProjectTasks: [],
    menuLabelsEditMode: {
      isEdit: false,
      label:{},
    },
    menuLabelsList: [],
    taskDetails:{}
  },
  reducers: {
    setAllComments: (state, action) => { 
        state.allComments = action.payload
    },
    setBoardActivity: (state, action) => {
        state.boardActivities = action?.payload;
    },
    setMyProjectTasks: (state, action) => {
        state.myProjectTasks = action?.payload;
    },
    enableMenuLabelEditMode: (state, action) => { 
      state.menuLabelsEditMode = {
        isEdit: true,
        label: action?.payload, 
      };
    },
    disableMenuLabelEditMode: (state) => { 
      state.menuLabelsEditMode = {
        isEdit: false,
        label: {}, 
      };
    },
    setMenuLabelsList: (state, action) => {
      state.menuLabelsList = action?.payload;
    },
    setTaskDetails: (state, action) => {
      state.taskDetails = action?.payload;
    },
  }
});
export const {
    setAllComments,
    setBoardActivity,
    setMyProjectTasks,
    enableMenuLabelEditMode,
    disableMenuLabelEditMode,
    setMenuLabelsList,
    setTaskDetails

} = tasks.actions;

export default tasks.reducer;
